import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';
import useVideoChatController from '../../../services/remoteOralExam/useVideoChatController';
import styles from '../RemoteOralExam.scss';

const ZoomFrame = React.memo(({ frameSrc }) => {
    useVideoChatController(frameSrc);

    return frameSrc
        ? <iframe
            title={t('remoteOralExam.inProgress.videoCallTitle')}
            className={styles.zoomIntegration}
            src={frameSrc}
            allow="cross-origin-isolated"
        />
        : null;
});

ZoomFrame.propTypes = {
    frameSrc: PropTypes.string,
};

export default ZoomFrame;
